"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.button_am = void 0;
var static_values_1 = require("../../../src/core/static-values");
function button_am(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, hasReturnVal = utils.hasReturnVal, use = utils.use, cySelectSegment = utils.cySelectSegment, cyInput = utils.cyInput, IDs = utils.IDs;
    var _a = static_values_1.staticValues.buttonAM, labelValue = _a.labelValue, inputValue = _a.inputValue, cpuValue = _a.cpuValue;
    var clickBtn1 = function () { return cy.get("#".concat(IDs.buttonIDs.amID)).click().wait(10).then(cyInput); };
    describe("Button AM - ".concat(labelValue), function () {
        it('Arrow key functions', function () {
            loadPrimaryInput()
                .then(clickBtn1)
                .should('have.value', inputValue)
                .then(hasReturnVal(cpuValue))
                .then(function () {
                // Need to make sure the basic functions still work after clicking a button
                return cySelectSegment('hrs12')
                    .then(use.upArrow)
                    .should('have.value', '08:15 AM')
                    .then(use.downArrow)
                    .then(use.downArrow)
                    .should('have.value', '06:15 AM')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '06:16 AM')
                    .then(use.downArrow)
                    .then(use.downArrow)
                    .should('have.value', '06:14 AM')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '06:14 PM')
                    .then(use.downArrow)
                    .should('have.value', '06:14 AM')
                    .then(use.del)
                    .should('have.value', '06:14 --')
                    .then(use.leftArrow)
                    .then(use.backspace)
                    .should('have.value', '06:-- --')
                    .then(use.leftArrow)
                    .then(use.del)
                    .should('have.value', '--:-- --');
            });
        });
        it('Can press button twice', function () {
            loadPrimaryInput()
                .then(clickBtn1)
                .should('have.value', inputValue)
                .then(hasReturnVal(cpuValue))
                .then(function () {
                // Need to make sure the basic functions still work after clicking a button
                return cySelectSegment('hrs12')
                    .then(use.upArrow)
                    .should('have.value', '08:15 AM')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '08:16 AM')
                    .then(use.rightArrow)
                    .then(use.upArrow)
                    .should('have.value', '08:16 PM')
                    .then(clickBtn1)
                    .should('have.value', '07:15 AM');
            });
        });
    });
}
exports.button_am = button_am;
